import { render, staticRenderFns } from "./BuyPlayerConfirmation.vue?vue&type=template&id=6f70f168&scoped=true&"
import script from "./BuyPlayerConfirmation.vue?vue&type=script&lang=js&"
export * from "./BuyPlayerConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./BuyPlayerConfirmation.vue?vue&type=style&index=0&id=6f70f168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70f168",
  null
  
)

export default component.exports